import React, { Component } from 'react'
import AsyncSelect from 'react-select/lib/Async'
import { pxToRem, color, ie } from '../../utils'

const customStyles = {
  valueContainer: (base, state) => ({
    ...base,
    display: 'inline-grid',
    padding: 0
  }),
  control: (base, state) => {
    const { selectProps = {} } = state

    return {
    ...base,
    background: 'none',
    border: '0px',
    borderRadius: '0px',
    boxShadow: '',
    fontFamily: `'Open Sans', sans-serif`,
    fontSize: pxToRem(16),
    width: selectProps.width || pxToRem(200)
  }},
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: 0
  }),
  option: (base, state) => {
    const styles = {
      ...base,
      fontFamily: `'Open Sans', sans-serif`,
      fontSize: pxToRem(13),
      fontWeight: '400',
      overflow: 'hidden'
    }

    if (state.isFocused && !state.isSelected) {
      styles.background = '#f4f7f9'
    } else if (state.isSelected) {
      styles.background = color.secondary
    }

    return styles
  },
  indicatorSeparator: (base, state) => ({}),
  input: (base, state) => ({
    ...base,
    fontFamily: `'Open Sans', sans-serif`,
    fontSize: pxToRem(17)
  }),
  singleValue: (base, state) => ({
    ...base,
    color: color.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }),
  menuList: (base, state) => ({
    ...base,
    margin: '0',
    padding: '0',
    fontSize: `${pxToRem(14)}`
  })
}

export default class DropDown extends Component {
  render() {
    const { ...rest } = this.props

    return (
      <AsyncSelect
        {...rest}
        defaultOptions={!ie.isIe11()}
        isSearchable={true}
        styles={customStyles}
        loadingMessage={() => {
          return 'Carregando...'
        }}
        placeholder="Selecione uma área"
        noOptionsMessage={select => {
          return select.inputValue ? 'Nenhum resultado encontrado' : 'Digite o nome da área'
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DropDown/DropDown.js